import * as jsPDF from 'jspdf';
import 'jspdf-autotable'
import invoicePDF from 'common/assets/Invoice.jpg'
import invoiceTotalPDF from 'common/assets/InvoiceTotal.jpg'
import proformaPDF from 'common/assets/Proforma.png'
import proformaTotalPDF from 'common/assets/ProformaTotal.png'
import addFont from 'invoices/services/addFontsPDFUseCase'
import findInvoiceDetailByIdUseCase from './detail/findInvoiceDetailByIdUseCase';
import findClientByTask from 'tasks/services/sign/findClientByTask';
import { calculateTotalInvoice, calculateTotalItem } from './detail/calculateInvoicesInfo';
import { pad, renderDate } from 'common/services/util';
import { mapPaymentMode } from './config';
import { storage } from "common/config/Firebase"

const createPDFInvoiceUseCase = async ({ invoiceData, initialInvoiceDetailData, operation, isProforma }) => {
    const { invoiceDetailData, clientData } = await findAllData({ invoiceData, invoiceDetailData: initialInvoiceDetailData })

    const doc = new jsPDF('p', 'mm', 'a4');
    const width = doc.internal.pageSize.getWidth();
    const height = doc.internal.pageSize.getHeight();

    addFont(doc)

    const maxItemsByPage = 8
    const itemsChunks = spliceIntoChunks([...invoiceDetailData.data], maxItemsByPage)

    if (itemsChunks.length === 0) {
        alert("No se puede imprimir una factura sin elementos")
        return
    }

    itemsChunks.forEach((items, index) => {
        const isFirstPage = index === 0
        const isLastPage = index === itemsChunks.length - 1
        const imgInvoice = new Image()

        if (isProforma) {
            imgInvoice.src = isLastPage ? proformaTotalPDF : proformaPDF
            doc.addImage(imgInvoice, 'PNG', 0, 0, width, height, '', 'FAST')
        } else {
            imgInvoice.src = isLastPage ? invoiceTotalPDF : invoicePDF
            doc.addImage(imgInvoice, 'PNG', 0, 0, width, height, '', 'FAST')
        }

        const widthStart = width * 0.04
        headerData(doc, widthStart, height, width, index + 1, invoiceData, isProforma)

        if (isFirstPage) {
            ifenoData(doc, widthStart, height * 0.21, 6)
            clientInfoData(doc, width * 0.62, height * 0.165, clientData)
        }

        const heightTable = isFirstPage ? height * 0.345 : height * 0.2
        tableData(doc, heightTable, items, invoiceData.ivaPercent)

        if (isLastPage) {
            invoiceInfoData(doc, width * 0.62, height * 0.69, 6, calculateTotalInvoice(invoiceDetailData.data, invoiceData.ivaPercent), invoiceData.ivaPercent)
            bankData(doc, widthStart, height * 0.76, 6)
        }

        afterPage(doc, widthStart, height * 0.9)

        if (!isLastPage) {
            doc.addPage()
        }
    })

    if (operation === "email") {
        const type = isProforma ? "PROFORMA" : "FACTURA";
        let nameFile =
            (clientData.name || "CLIENTE") +
            "_" +
            type +
            "_" +
            pad(invoiceData.numInvoice, 5) +
            ".pdf";

        nameFile = nameFile.replace(/ /g, "_");

        const uri = doc.output("datauristring");
        const ref = storage.ref().child(`${nameFile}`);
        await ref.putString(uri, "data_url");
        const url = await ref.getDownloadURL();

        return url; // devolvemos la URL para el correo
    }

    if (operation === "upload" | operation === "clipboard") {
        const type = isProforma ? "PROFORMA" : "FACTURA"
        let nameFile = clientData.name + "_" + type + "_" + pad(invoiceData.numInvoice, 5) + ".pdf"
        nameFile = nameFile.replace(/ /g, "_")

        const uri = doc.output('datauristring')
        const ref = storage.ref().child(`${nameFile}`)
        await ref.putString(uri, 'data_url')
        const url = await ref.getDownloadURL()
        const msg = `Estimado cliente, le contactamos desde el Servicio Técnico de IFENO. A través del siguiente enlace, podrá descargar su ${type}: ${url}`

        navigator.clipboard.writeText(msg).catch(() => {
            const el = document.createElement('textarea');
            el.value = msg;
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
        });

        if (operation === "clipboard") {
            alert("Factura copiada!")
            return
        }

        if (!clientData || !clientData.phone) {
            alert("El cliente no tiene teléfono, pero se ha copiado el mensaje.")
            return
        }

        const isMobileDevice = (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
        if (isMobileDevice) {
            const url = `whatsapp://send?phone=${clientData.phone}&text=${msg}`;
            window.location.href = url;
            return
        }

        window.open(`https://api.whatsapp.com/send?phone=34${clientData.phone}&text=${msg}`)
        return
    }

    if (operation === "print") {
        doc.autoPrint()
    }

    if (operation === "print" || operation === "view") {
        const blob = doc.output('blob');
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');
        setTimeout(() => URL.revokeObjectURL(url), 100);
    }

    if (operation === "save") {
        const type = isProforma ? "PROFORMA" : "FACTURA"
        doc.save(clientData.name + "-" + type + "-" + pad(invoiceData.numInvoice, 5) + ".pdf")
    }
}

const findAllData = async ({ invoiceData, invoiceDetailData }) => {
    if (!invoiceDetailData) {
        invoiceDetailData = await findInvoiceDetailByIdUseCase(invoiceData.id)
    }

    const clientData = invoiceData.dniClient
        ? await findClientByTask(invoiceData.dniClient)
        : {}

    return {
        invoiceDetailData,
        clientData
    }
}

const headerData = (doc, widthStart, height, width, numPage, invoiceData, isProforma) => {
    const paymentMode = invoiceData.paymentMode ? mapPaymentMode[invoiceData.paymentMode] : ""

    doc.setFont("ML")
    doc.setFontSize(14)
    doc.setTextColor(255, 255, 255)
    doc.text(renderDate(invoiceData.invoiceDate), widthStart, height * 0.112)
    doc.text(paymentMode, widthStart + 37, height * 0.112)

    doc.setFont("sm_bold")
    doc.setFontSize(24)
    const type = isProforma ? "Proforma" : "Factura"
    doc.text(type, width * 0.82, height * 0.06)
    doc.setFontSize(14)
    doc.text(pad(invoiceData.numInvoice, 5), width * 0.82 + 15, height * 0.08)

    doc.setFontSize(12)
    doc.text(`Página ${numPage}`, width * 0.82 + 14, height * 0.12)

    doc.setTextColor(0, 0, 0)
}

const ifenoData = (doc, widthStart, heightStart, step) => {
    doc.setFont('bold')
    doc.setFontSize(16)
    doc.setTextColor('#2E51C2')
    doc.text('IFENO Mobile Solutions SL', widthStart, heightStart)
    heightStart += 7.5

    doc.setFont('ML')
    doc.setTextColor(0, 0, 0)
    doc.setFontSize(12)
    const texts = ["CIF B74459140",
        "C/ Fuertes Acevedo, 56",
        "33006, Oviedo, Asturias",
        "985 072 053",
        "info@ifeno.es"]

    texts.forEach(text => {
        doc.text(text, widthStart, heightStart)
        heightStart += step
    })
}

const clientInfoData = (doc, widthStart, heightStart, clientData) => {
    const { name, id: dni, locality, mail, phone, postcode, street, community } = clientData
    const maxWidth = 80

    doc.setFont('sm_bold')
    doc.setFontSize(16)
    doc.text("Datos del cliente", widthStart, heightStart)

    heightStart += 6.5
    doc.setFont('bold')
    doc.setTextColor('#2E51C2')
    doc.text(name || "", widthStart, heightStart, { maxWidth })

    doc.setFont('ML')
    doc.setTextColor(0, 0, 0)
    doc.setFontSize(12)
    heightStart += 12

    const texts = [
        `NIF ${dni || ""}`,
        `${street || ""}`,
        `${postcode || ""}, ${locality || ""}, ${community || ""}`,
        phone ? phone + "" : "",
        mail || ""
    ]

    if (street && street.length > 33) {
        texts.splice(2, 0, "")
    }

    const step = 6
    texts.forEach(text => {
        doc.text(text, widthStart, heightStart, { maxWidth })
        heightStart += step
    })
}

const tableData = (doc, heightStart, data, numberIVA) => {
    const columns = [
        { title: "REF.", dataKey: "reference" },
        { title: "CONCEPTO", dataKey: "description" },
        { title: "CANTIDAD", dataKey: "units" },
        { title: "PRECIO/UD", dataKey: "unitPrice" },
        { title: "IMPORTE (Sin IVA)", dataKey: "totalPrice" }
    ]

    const header = [
        { "reference": "REF.", "description": "CONCEPTO", "units": "CANTIDAD", "unitPrice": "PRECIO/UD", "totalPrice": "IMPORTE (Sin IVA)" }
    ]

    const dataRender = calculateTotalItem(data).map(item => {
        item.unitPrice = renderNumberPriceWithoutIVA(item.unitPrice, item.iva, numberIVA)
        item.totalPrice = renderNumberPriceWithoutIVA(item.totalPrice, item.iva, numberIVA)
        return item
    })

    doc.autoTable(columns, [...header, ...dataRender], {
        theme: 'grid',
        styles: { fontSize: 11, cellPadding: 2.7, overflow: 'linebreak' },
        showHeader: 'never',
        columnStyles: {
            "reference": { columnWidth: 20, fillColor: '#efefef' },
            "description": { fillColor: false },
            "units": { columnWidth: 26, fillColor: '#efefef' },
            "unitPrice": { columnWidth: 28, fillColor: false, halign: 'right' },
            "totalPrice": { columnWidth: 40, fillColor: '#efefef', halign: 'right' },
        },
        startY: heightStart,
        margin: 6,
        drawCell: (cell, data) => {
            doc.setFont('ML')
            doc.setTextColor(0, 0, 0)

            if (columns.map(c => c.title).includes(cell.raw)) {
                doc.setFont("bold")
                doc.setTextColor("#2E51C2")
            }
        }
    });
}

const bankData = (doc, widthStart, heightStart, step) => {
    doc.setFont('ML')

    doc.setFontSize(16)
    doc.text("Datos bancarios", widthStart, heightStart)

    heightStart += 8.5

    doc.setFontSize(12)
    doc.text("Banco:", widthStart, heightStart)
    doc.text("BBVA", widthStart + 77, heightStart)

    heightStart += step
    doc.text("Nombre:", widthStart, heightStart)
    doc.text("ES17 0182 0668 0202 0157 2052", widthStart + 25, heightStart)

    heightStart += step
    doc.text("Titular:", widthStart, heightStart)
    doc.text("IFENO MOBILE SOLUTIONS S.L.", widthStart + 27, heightStart)
}

const invoiceInfoData = (doc, widthStart, heightStart, step, { ivaPrice, base, total }, ivaPercent) => {
    doc.setFont('ML')
    doc.setFontSize(12)

    const widthNumber = widthStart + 70

    doc.text("Tipo:", widthStart, heightStart)
    doc.text(`${ivaPercent || 21} %`, widthNumber, heightStart, { maxWidth: "100", align: "right" })

    heightStart += step
    doc.text("Base imponible:", widthStart, heightStart)
    doc.text(renderNumberPrice(base, true), widthNumber, heightStart, { maxWidth: "100", align: "right" })

    heightStart += step
    doc.text("IVA:", widthStart, heightStart)
    doc.text(renderNumberPrice(ivaPrice, true), widthNumber, heightStart, { maxWidth: "100", align: "right" })

    heightStart += 11
    doc.setFontSize(14)
    doc.setFont('bold')
    doc.setTextColor(255, 2555, 255)
    doc.text("TOTAL (IVA incl.):", widthStart, heightStart)
    doc.text(renderNumberPrice(total, true), widthNumber, heightStart, { maxWidth: "100", align: "right" })
    doc.setTextColor(0, 0, 0)
}

const afterPage = (doc, widthStart, heightStart) => {
    doc.setFont('ML')
    doc.setFontSize(14)
    doc.setTextColor(255, 255, 255);
    doc.text("¡Gracias por confiar en nosotros!", widthStart, heightStart)

    doc.setFont('regular')
    doc.setFontSize(7)
    doc.text("Inscrita en el R.M. de Asturias . Tomo 4351, Folio 115, Hoja AS 55149", widthStart + 117, heightStart + 4.5)

    const texts = [
        "IFENO, Responsable del tratamiento de sus datos de carácter personal, le informa conforme a lo previsto en el RGPD de 27 de abril de 2016, que recaba y trata sus",
        "datos de carácter personal, aplicando las medidas técnicas y organizativas que establece el presente Reglamento con la finalidad de gestionar la relación que le",
        "incula con el Responsable, así como poder remitirle cualquier tipo de comunicación a través de los medios designados al efecto. Usted da, como titular de sus",
        "datos, su consentimiento y autorización para dicho tratamiento. Podrá ejercitar los derechos de acceso, rectificación, supresión, limitación, portabilidad y oposición",
        "dirigiéndose al Responsable con dirección CALLE FUERTES ACEVEDO, 56,OVIEDO,33006,ASTURIAS."
    ]

    doc.setTextColor(0, 0, 0);
    doc.setFontSize(7.5)
    heightStart += 12.5
    const step = 3.2
    texts.forEach(text => {
        doc.text(text, widthStart, heightStart)
        heightStart += step
    })
}

const spliceIntoChunks = (arr, chunkSize) => {
    const res = [];
    let tempArr = [...arr];
    let added = 1;
    arr.forEach((t, i) => {
        if (t.description && t.description.length > 40) {
            tempArr = insert(tempArr, i + added, null)
            added++
        }

        if (t.description && t.description.length > 60) {
            tempArr = insert(tempArr, i + added, null)
            added++
        }
    })
    while (tempArr.length > 0) {
        res.push(tempArr.splice(0, chunkSize).filter(t => t !== null));
        const primerIndiceValido = tempArr.findIndex(elemento => elemento !== null);
        tempArr = primerIndiceValido !== -1 ? tempArr.slice(primerIndiceValido) : [];
    }
    return res;
}

const insert = (arr, index, newItem) => [
    // part of the array before the specified index
    ...arr.slice(0, index),
    // inserted item
    newItem,
    // part of the array after the specified index
    ...arr.slice(index)
]

const renderNumberPrice = (number, iva, numberIVA = 21) => {
    const ivaPercent = parseFloat(numberIVA) / 100
    number = number ? parseFloat(number) : 0
    number = iva ? number : number * (1 + ivaPercent)
    return `${number.toFixed(2).replace(".", ",")} €`
}

const renderNumberPriceWithoutIVA = (number, iva, numberIVA = 21) => {
    const ivaPercent = parseFloat(numberIVA) / 100
    number = number ? parseFloat(number) : 0
    number = iva ? number / (1 + ivaPercent) : number
    return `${number.toFixed(2).replace(".", ",")} €`
}

export default createPDFInvoiceUseCase